/* KBW vanity grid.
 *
 * Custom script: not part of the Maximize theme, so a theme update will
 * never overwrite it.
 *
 * Carried over from `kbw-flooring-grid.js` (KBW-80's approved pattern):
 * every card is already in the page, printed server-side. This only hides
 * the ones a filter has ruled out and reorders the ones a sort has asked
 * for -- no fetch, no re-render, so a crawler and a no-JS visitor both see
 * all 150 regardless.
 *
 * The one real difference: flooring filters on a single group, so "any
 * checkbox checked" was the whole rule. This page filters on four groups at
 * once (Bowl, Mount, Collection, Width) -- a card must match every group
 * that has a selection in it (AND across groups), while values inside one
 * group still combine by OR (checking both Single and Double shows either).
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-kbw-vn]').forEach(initVanityGrid);

  function initVanityGrid(root) {
    var grid = root.querySelector('[data-kbw-vn-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-vn-card]'));
    var originalOrder = cards.slice();
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-vn-filter]'));
    var countEl = root.querySelector('[data-kbw-vn-count]');
    var emptyEl = root.querySelector('[data-kbw-vn-empty]');
    var resetBtn = root.querySelector('[data-kbw-vn-reset]');
    var sortSelect = root.querySelector('[data-kbw-vn-sort]');

    if (!grid || !cards.length) return;

    function checkedByGroup() {
      var byGroup = {};
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var group = cb.dataset.group;
        if (!byGroup[group]) byGroup[group] = [];
        byGroup[group].push(cb.value);
      });
      return byGroup;
    }

    function applyFilter() {
      var byGroup = checkedByGroup();
      var groups = Object.keys(byGroup);
      var anyChecked = groups.length > 0;
      var visible = 0;
      cards.forEach(function (card) {
        var show = groups.every(function (group) {
          return byGroup[group].indexOf(card.dataset[group]) !== -1;
        });
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (countEl) countEl.innerHTML = '<b>' + visible + '</b> ' + (visible === 1 ? 'vanity' : 'vanities');
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (resetBtn) resetBtn.hidden = !anyChecked;
      if (window.KbwRail) window.KbwRail.refresh(root);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilter();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var value = sortSelect.value;
        var sorted;
        if (value === 'width') {
          sorted = cards.slice().sort(function (a, b) {
            return (parseFloat(a.dataset.width) || 0) - (parseFloat(b.dataset.width) || 0);
          });
        } else if (value === 'title') {
          sorted = cards.slice().sort(function (a, b) {
            return a.dataset.title.localeCompare(b.dataset.title, undefined, { numeric: true });
          });
        } else if (value === 'newest') {
          sorted = cards.slice().sort(function (a, b) {
            return (parseInt(b.dataset.created, 10) || 0) - (parseInt(a.dataset.created, 10) || 0);
          });
        } else {
          sorted = originalOrder.slice();
        }
        sorted.forEach(function (card) { grid.appendChild(card); });
      });
    }

    // --- the rail, "Show more" and the phone drawer ---------------------------
    // KBW: assets/kbw-filter-rail.js, the site's one filter rail standard
    // (client, 2026-09-15). What is left here is this list's own filtering.

    // --- a filter pre-selected from the URL ---------------------------------
    // The header's Single / Double / Standing / Floating menu cards each link
    // here with ?bowl=Single or ?mount=Standing so the page lands already
    // filtered to the one the visitor chose -- one list, several ways in.
    // Recognised keys match a checkbox's data-group exactly; an unrecognised
    // key, an unrecognised value, or no query string at all just leaves
    // every card showing.
    try {
      var params = new URLSearchParams(window.location.search);
      ['bowl', 'mount', 'collection', 'width'].forEach(function (group) {
        var wanted = params.get(group);
        if (!wanted) return;
        checkboxes.forEach(function (cb) {
          if (cb.dataset.group === group && cb.value === wanted) cb.checked = true;
        });
      });
    } catch (e) {
      /* URLSearchParams missing or malformed query string -- leave everything showing */
    }
    applyFilter();
  }
})();
